<template>
  <div>
    <div class="md-card md-card-tabs">
      <div class="md-card-content">
        <div class="box_head">
          <div class="lines_box">
            <div class="line_box text_right">
              <span class="seller_line_1" :style="{width:dueData+'%'}"></span>
            </div>
            <div class="line_box text_right">
              <span class="seller_line_2" :style="{width:(100 - sellDate)+'%'}"></span>
            </div>
            <div class="line_3 line_box">
              <span class="seller_line_3" :style="{width:sellDate+'%'}"></span>
            </div>
          </div>
          <div class="point_box">
            <div
              class="point_item"
              :style="{left:item.x+'%',right:item.r+'%'}"
              v-for="item in pointList"
              :key="item.text"
            >
              <span class></span>
              {{item.text}}
            </div>
          </div>
        </div>
        <div v-show="displayChart" class="flex flex_between">
          <chartUnit class="flex_1" unitIndex="1" :unitInfo="durationOnBalance" ></chartUnit>
          <chartUnit class="flex_1" unitIndex="2" :unitInfo="advancedDays" ></chartUnit>
          <chartUnit class="flex_1" unitIndex="3" :unitInfo="latePaymentDays" ></chartUnit>
        </div>
        <emptyChart v-show="!displayChart"></emptyChart>
      </div>
    </div>
  </div>
</template>
<script>
import chartUnit from "./chartUnit";
import EmptyChart from "@/views/dashboard/EmptyChart";

import { mapGetters } from "vuex";
export default {
  components: {
    chartUnit,
    EmptyChart
  },
  data() {
    return {
      pointList: [
        { text: this.$t("common.invoiceDate"), x: 0 },
        { text: this.$t("dashboard.PaymentChart.Selling.date"), x: 20 },
        { text: this.$t("investor.exchange.table.header.dueDate"), x: "", r: 30 },
        { text: this.$t("dashboard.PaymentChart.payment"), x: "", r: 0 }
      ],
      sellDate: 20,
      dueData: 30,
      chartList: [[], [], []],
      durationOnBalance: [],
      advancedDays: [],
      latePaymentDays: [],
      displayChart: true
    };
  },
  mounted() {},
  computed: {
    ...mapGetters({ dashboardInfo: "dashboardInfo" }),
    realList() {
      return this.chartList;
    }
  },
  watch: {
    dashboardInfo() {
      // durationOnBalance advancedDays
      // latePaymentDays
      let { statisticData } = this.dashboardInfo;
      let hasData = false;
      if (statisticData) {
        let {
          durationOnBalance,
          advancedDays,
          latePaymentDays
        } = statisticData;
        if ((durationOnBalance && durationOnBalance.length >0)
              || (advancedDays && advancedDays.length >0)
              || (advancedDays && advancedDays.length >0)) {
          hasData = true;
        }
        this.chartList[0] = durationOnBalance;
        this.chartList[1] = advancedDays;
        this.chartList[2] = latePaymentDays;
        this.durationOnBalance=durationOnBalance
        this.advancedDays=advancedDays
        this.latePaymentDays=latePaymentDays
      } else {
        this.chartList = [[], [], []];
      }
      this.displayChart = hasData;
    }
  }
};
</script>
<style lang="scss">
.box_head {
  padding: 10px 0 50px 0;
}
.lines_box {
  padding: 0 30px;
}
.line_box {
  line-height: 5px;
  span {
    display: inline-block;
    height: 5px;
    &.seller_line_1 {
      background: #FE766C;
    }
    &.seller_line_2 {
      background: #FEC07D;
    }
    &.seller_line_3 {
      background: #A6D1F9;
    }
  }
}
.point_box {
  position: relative;
  .point_item {
    position: absolute;
    display: flex;
    align-items: center;
    flex-direction: column;
  }
  span {
    display: inline-block;
    width: 0;
    height: 0;
    border-bottom: 5px solid #333;
    border-right: 5px solid transparent;
    border-left: 5px solid transparent;
  }
}
</style>